
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0c4.962 0 9 4.037 9 9a8.956 8.956 0 01-1.971 5.615l5.678 5.678-1.414 1.414-5.678-5.678A8.956 8.956 0 019 18c-4.962 0-9-4.037-9-9s4.038-9 9-9zm0 2C5.14 2 2 5.141 2 9s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7z"}})])
          )
        }
      }
    